import authContainer from './authContainer';
// import { HttpStatusCode } from './HttpStatusCode';
// import store from '../store';

export class LoginManager {
    addAuthServerUrl(url) {
        return process.env.VUE_APP_COMMHUB_URL + url;
    } 

    async requestPassReset() {
        // let response;
        // try {
        //     response = await ky.post(this.addAuthServerUrl("/auth/requestPassReset"), { json: requestPassResetVM });
        // }
        // catch(e) {
        //     return { success: false, error: e };
        // }

        // const result = new ServerResult(response);
        alert('Internal password reset is not supported. Please, proceed to your Microsoft account to reset password!')

        return {};
    }
    async resetPassword() {
        // let response;
        // try {
        //     response = await ky.post(this.addAuthServerUrl("/auth/resetPass"), { json: resetPassVM });
        // }
        // catch(e) {
        //     return { success: false, error: e };
        // }

        // const result = new ServerResult(response);

        alert('Internal password reset is not supported. Please, proceed to your Microsoft account to reset password!')

        return {};
    }

    async tryLogin() { 
        let response;
        try {
            response = await authContainer.login();
        }
        catch(e) {
            return { success: false, error: e };
        }
        if (response?.ok)
        {
            return { 
                success: response.ok,
                payload: response.value
            }
        }
        
        return { 
            success: false, 
            error: `Login request failed with error "${response.error}".` 
        };
    } 

    async checkJwtExpired() { 
        return true;
    }

    async tryRefreshJwt() {
        var result = await authContainer.refresh();

        if (result.ok) {
            return { success: result.ok, payload: result.value };
        }
        
        return  { success: false, error: `Invalid server response (${result.error})` };
    } 
}